import React from 'react'
import { connect } from 'react-redux'

import { AppState } from '@chegg-wt/core/state'
import SEOTitle from '@chegg-wt/core/components/SEOTitle'
import { LoadingDots } from '@chegg-wt/core/components/LoadingDots'
import { ProductName } from '@chegg-wt/core/types/site'
import { initializedSelector } from '@chegg-wt/core/state/app/selectors'
import { loggedInSelector } from '@chegg-wt/core/state/user/selectors'
import { BM_PRODUCT_NAME, CTFM_PRODUCT_NAME } from '@chegg-wt/core/constants/site'

import { authModalExpFlagSelector } from '@chegg-wt/core/state/createCitation/selectors'
import { openModal } from '@chegg-wt/core/state/modals/actions'
import { OpenModalPayload } from '@chegg-wt/core/state/modals/types'
import { ONE_AUTH_MODAL } from '@chegg-wt/core/state/modals/constants'
import HomePageFooter from '../HomePageFooter'

import { AuthModalOrigin } from '../Modals/AuthModal/types'
import NotLoggedIn from './NotLoggedIn'
import SubscriptionInfo from './SubscriptionInfo'
import { AccountContainer, AccountHeader, PageContainer, FooterContainer } from './styled'

/*
  If user NOT logged in
    show links to register + login
  If user logged in
    show link to Chegg subscription page
*/

export interface MyAccountProps {
  initialized: boolean
  notLoggedIn: boolean
  siteName: ProductName
  authModalExpFlag: boolean
  openModal: (payload: OpenModalPayload) => void
}

export const MyAccount: React.FunctionComponent<MyAccountProps> = ({
  initialized = false,
  notLoggedIn = false,
  siteName,
  authModalExpFlag,
  openModal,
}) => {
  const onSignInClick = () => {
    openModal({
      name: ONE_AUTH_MODAL,
      data: {
        defaultFlow: 'signin',
        origin: AuthModalOrigin.MYACCOUNT_PAGE,
      },
    })
  }

  const onRegisterClick = () => {
    openModal({
      name: ONE_AUTH_MODAL,
      data: {
        defaultFlow: 'signup',
        origin: AuthModalOrigin.MYACCOUNT_PAGE,
      },
    })
  }
  const tag = [CTFM_PRODUCT_NAME, BM_PRODUCT_NAME].includes(siteName) ? '™' : '®'
  let content: JSX.Element = <SubscriptionInfo siteName={siteName} tag={tag} />
  if (!initialized) {
    content = (
      <LoadingDots data-test="loading" message="Fetching your account information..." />
    )
  } else if (notLoggedIn) {
    content = (
      <NotLoggedIn
        showAuthModal={authModalExpFlag}
        onSignInClick={onSignInClick}
        onRegisterClick={onRegisterClick}
      />
    )
  }

  return (
    <PageContainer>
      <SEOTitle title={`My Account | ${siteName}`} enable={!!siteName} />
      <AccountContainer>
        <AccountHeader>My account</AccountHeader>
        {content}
      </AccountContainer>
      <FooterContainer>
        <HomePageFooter />
      </FooterContainer>
    </PageContainer>
  )
}

const mapStateToProps = (state: AppState) => ({
  initialized: initializedSelector(state),
  notLoggedIn: !loggedInSelector(state),
  authModalExpFlag: authModalExpFlagSelector(state),
})

const mapDispatchToProps = {
  openModal,
}

export default connect(mapStateToProps, mapDispatchToProps)(MyAccount)
